export const browse = {
  title: "Browse Screen",
  // browse_title_type_category_language_free:
  //   "Read {language.name} {category.name} {type.plural_name} Online",
  browse_title_type_category_language:
    "Read {{language.name}} {{category.name}} {{type.plural_name}} Online",
  browse_title_type_category:
    "Read {{category.name}} {{type.plural_name}} Online",
  browse_title_type_language:
    "Read {{language.name}} {{type.plural_name}} Online",
  browse_title_type: "Read {{type.plural_name}} Online",
  browse_title_category_language:
    "Read {{language.name}} {{category.name}} {{tabSuffix}} Online",
  browse_title_category: "Read {{category.name}} {{tabSuffix}} Online",
  browse_title_language: "Read {{language.name}} {{tabSuffix}} Online",
  browse_title: "All {{tabSuffix}}",
  searchPlaceholderComics: "Search series...",
  searchPlaceholderReleases: "Search releases...",
  searchPlaceholderCreators: "Search creators...",
  releases_title: "Releases",
  creators_title: "Community",
  filters: {
    apply: "Apply filters",
    clear: "Clear",
    clearAll: "Clear all",
  },
};
